import { SVGProps } from "react"

export const Light = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="309"
      height="142"
      viewBox="0 0 309 142"
      fill="none"
      {...props}
    >
      <g style={{ mixBlendMode: 'screen' }} clipPath="url(#clip0_4254_21829)">
        <g
          clipPath="url(#paint0_diamond_4254_21829_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(0.0145445 0.0542812 -0.26257 0.070355 159.5 155.207)">
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1005.87"
              fill="url(#paint0_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1005.87"
              transform="scale(1 -1)"
              fill="url(#paint0_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1005.87"
              transform="scale(-1 1)"
              fill="url(#paint0_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1005.87"
              transform="scale(-1)"
              fill="url(#paint0_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="-88.5249"
          y="279.843"
          width="112.392"
          height="543.664"
          transform="rotate(-105 -88.5249 279.843)"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:29.089092254638672,&#34;m01&#34;:-525.13928222656250,&#34;m02&#34;:407.5251464843750,&#34;m10&#34;:108.56240844726562,&#34;m11&#34;:140.71008300781250,&#34;m12&#34;:30.570447921752930},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <g
          clipPath="url(#paint1_diamond_4254_21829_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(-0.0448864 0.0338114 -0.163553 -0.217125 159.501 155.207)">
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1005.87"
              fill="url(#paint1_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1005.87"
              transform="scale(1 -1)"
              fill="url(#paint1_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1005.87"
              transform="scale(-1 1)"
              fill="url(#paint1_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1005.87"
              transform="scale(-1)"
              fill="url(#paint1_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="-48.9385"
          y="-28.1065"
          width="112.392"
          height="543.664"
          transform="rotate(-36.9896 -48.9385 -28.1065)"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:-89.772735595703125,&#34;m01&#34;:-327.10568237304688,&#34;m02&#34;:367.94015502929688,&#34;m10&#34;:67.6228027343750,&#34;m11&#34;:-434.24957275390625,&#34;m12&#34;:338.52005004882812},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <g
          clipPath="url(#paint2_diamond_4254_21829_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(-0.051901 0.0215472 -0.0799585 -0.192597 159.5 155.208)">
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              fill="url(#paint2_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(1 -1)"
              fill="url(#paint2_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1 1)"
              fill="url(#paint2_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1)"
              fill="url(#paint2_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="27.6406"
          y="-15.8422"
          width="112.392"
          height="417.071"
          transform="rotate(-22.5463 27.6406 -15.8422)"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:-103.80197143554688,&#34;m01&#34;:-159.91697692871094,&#34;m02&#34;:291.35983276367188,&#34;m10&#34;:43.094387054443359,&#34;m11&#34;:-385.1945800781250,&#34;m12&#34;:326.25787353515625},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <g
          clipPath="url(#paint3_diamond_4254_21829_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(-0.054534 -0.0135662 0.0503422 -0.202368 159.5 155.208)">
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              fill="url(#paint3_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(1 -1)"
              fill="url(#paint3_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1 1)"
              fill="url(#paint3_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1)"
              fill="url(#paint3_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="155.308"
          y="-60.7261"
          width="112.392"
          height="417.071"
          transform="rotate(13.9696 155.308 -60.7261)"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:-109.06794738769531,&#34;m01&#34;:100.68443298339844,&#34;m02&#34;:163.69142150878906,&#34;m10&#34;:-27.132312774658203,&#34;m11&#34;:-404.73574829101562,&#34;m12&#34;:371.14199829101562},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <g
          clipPath="url(#paint4_diamond_4254_21829_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(-0.035756 -0.0433532 0.160878 -0.132685 159.5 155.207)">
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              fill="url(#paint4_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(1 -1)"
              fill="url(#paint4_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1 1)"
              fill="url(#paint4_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1)"
              fill="url(#paint4_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="284.621"
          y="-20.8317"
          width="112.392"
          height="417.071"
          transform="rotate(50.4855 284.621 -20.8317)"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:-71.512031555175781,&#34;m01&#34;:321.75546264648438,&#34;m02&#34;:34.377902984619141,&#34;m10&#34;:-86.706413269042969,&#34;m11&#34;:-265.37091064453125,&#34;m12&#34;:331.24578857421875},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <g
          clipPath="url(#paint5_diamond_4254_21829_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(-0.00293968 -0.0561191 0.20825 -0.0109086 159.499 155.207)">
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              fill="url(#paint5_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(1 -1)"
              fill="url(#paint5_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1 1)"
              fill="url(#paint5_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1)"
              fill="url(#paint5_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="364.809"
          y="88.1793"
          width="112.392"
          height="417.071"
          transform="rotate(87.0014 364.809 88.1793)"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:-5.8793587684631348,&#34;m01&#34;:416.50,&#34;m02&#34;:-45.811508178710938,&#34;m10&#34;:-112.23816680908203,&#34;m11&#34;:-21.817228317260742,&#34;m12&#34;:222.23493957519531},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <g
          clipPath="url(#paint6_diamond_4254_21829_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(0.0310308 -0.0468517 0.17386 0.115151 159.501 155.207)">
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              fill="url(#paint6_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(1 -1)"
              fill="url(#paint6_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1 1)"
              fill="url(#paint6_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.65"
              transform="scale(-1)"
              fill="url(#paint6_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="364.392"
          y="223.506"
          width="112.392"
          height="417.071"
          transform="rotate(123.517 364.392 223.506)"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:62.06164550781250,&#34;m01&#34;:347.71987915039062,&#34;m02&#34;:-45.389564514160156,&#34;m10&#34;:-93.703384399414062,&#34;m11&#34;:230.30220031738281,&#34;m12&#34;:86.907501220703125},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <g
          clipPath="url(#paint7_diamond_4254_21829_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(-0.0101237 0.0552766 -0.212581 -0.0389337 159.5 155.207)">
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.38"
              fill="url(#paint7_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.38"
              transform="scale(1 -1)"
              fill="url(#paint7_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.38"
              transform="scale(-1 1)"
              fill="url(#paint7_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="1028.38"
              height="1007.38"
              transform="scale(-1)"
              fill="url(#paint7_diamond_4254_21829)"
              opacity="1"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="-63.2046"
          y="171.55"
          width="112.392"
          height="432.234"
          transform="rotate(-79.6215 -63.2046 171.55)"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.49803921580314636,&#34;g&#34;:0.49803921580314636,&#34;b&#34;:0.49803921580314636,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.0,&#34;g&#34;:0.0,&#34;b&#34;:0.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:-20.247497558593750,&#34;m01&#34;:-425.16226196289062,&#34;m02&#34;:382.20516967773438,&#34;m10&#34;:110.55324554443359,&#34;m11&#34;:-77.867424011230469,&#34;m12&#34;:138.86410522460938},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
      </g>
      <defs>
        <clipPath id="paint0_diamond_4254_21829_clip_path">
          <rect
            x="-88.5249"
            y="279.843"
            width="112.392"
            height="543.664"
            transform="rotate(-105 -88.5249 279.843)"
          />
        </clipPath>
        <clipPath id="paint1_diamond_4254_21829_clip_path">
          <rect
            x="-48.9385"
            y="-28.1065"
            width="112.392"
            height="543.664"
            transform="rotate(-36.9896 -48.9385 -28.1065)"
          />
        </clipPath>
        <clipPath id="paint2_diamond_4254_21829_clip_path">
          <rect
            x="27.6406"
            y="-15.8422"
            width="112.392"
            height="417.071"
            transform="rotate(-22.5463 27.6406 -15.8422)"
          />
        </clipPath>
        <clipPath id="paint3_diamond_4254_21829_clip_path">
          <rect
            x="155.308"
            y="-60.7261"
            width="112.392"
            height="417.071"
            transform="rotate(13.9696 155.308 -60.7261)"
          />
        </clipPath>
        <clipPath id="paint4_diamond_4254_21829_clip_path">
          <rect
            x="284.621"
            y="-20.8317"
            width="112.392"
            height="417.071"
            transform="rotate(50.4855 284.621 -20.8317)"
          />
        </clipPath>
        <clipPath id="paint5_diamond_4254_21829_clip_path">
          <rect
            x="364.809"
            y="88.1793"
            width="112.392"
            height="417.071"
            transform="rotate(87.0014 364.809 88.1793)"
          />
        </clipPath>
        <clipPath id="paint6_diamond_4254_21829_clip_path">
          <rect
            x="364.392"
            y="223.506"
            width="112.392"
            height="417.071"
            transform="rotate(123.517 364.392 223.506)"
          />
        </clipPath>
        <clipPath id="paint7_diamond_4254_21829_clip_path">
          <rect
            x="-63.2046"
            y="171.55"
            width="112.392"
            height="432.234"
            transform="rotate(-79.6215 -63.2046 171.55)"
          />
        </clipPath>
        <linearGradient
          id="paint0_diamond_4254_21829"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_diamond_4254_21829"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_diamond_4254_21829"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_diamond_4254_21829"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_diamond_4254_21829"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_diamond_4254_21829"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_diamond_4254_21829"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_diamond_4254_21829"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_4254_21829">
          <rect
            width="554.022"
            height="527.023"
            fill="white"
            transform="translate(169.045 537.414) rotate(-135)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
